export default __webpack_public_path__ + "static/media/sticker-O.9aec501f.png";